import React from "react";
import PlaceholderPage from "../../modules/shared/component/PlaceholderPage";

const MOU: React.FC = () => {
  return <PlaceholderPage title="MOU (Memorandum of Understanding)" />;
};

export default MOU;